"use client";

import { useState, useEffect } from "react";
import { Segmant, Title } from "../../../components/index.js";
import CityMapWrapper from "./CityMapWrapper.js";

export default function CityMapSection({ cityDetails, isMobile = false }) {
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");

  useEffect(() => {
    if (cityDetails && cityDetails?.length > 0) {
      const cityData = cityDetails[0];
      if (cityData.latitude) {
        setLat(parseFloat(cityData.latitude));
      }
      if (cityData.longitude) {
        setLng(parseFloat(cityData.longitude));
      }
    }
  }, [cityDetails]);

  const handleviewclick = () => {
    if (!cityDetails || cityDetails.length === 0) return;

    let cityname = cityDetails?.[0]?.postalcity_name || "";
    let statename = cityDetails?.[0]?.label?.split(",")?.pop()?.trim() || "";

    const address = `${cityname},${statename}, USA`;
    const url = `${window.location.protocol}//${window.location.host}/?address=${address}`;
    window.open(url, "_blank");
  };

  if (!cityDetails || cityDetails.length === 0) {
    return null;
  }

  return (
    <>
      <Segmant>
        <Title name="City Map" size="medium" as="h2" />
        <div className="detailnh_map_right">
          {lat !== "" && lng !== "" && (
            <CityMapWrapper
              lat={lat}
              lng={lng}
              cityname={cityDetails?.[0]?.postalcity_name}
              statename={cityDetails?.[0]?.label?.split(",")?.pop()}
              mapheight={300}
            />
          )}
        </div>
      </Segmant>
      <p onClick={handleviewclick} className="fullmapview">
        View Full Map
      </p>
    </>
  );
}
